// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');
'use strict';
module.exports = require('./').polyfill();



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/es6-promise@4.2.8/~/es6-promise/auto.js
// module id = Kbm6
// module chunks = 5